import { FC } from 'react'

import { useSuspenseQuery } from '@tanstack/react-query'

import { Typography } from '@forto-dev/phoenix-ui-core'
import { Cluster, Icon, Stack } from '@forto-dev/phoenix-ui-core/common'
import { Widget, WidgetFooter, WidgetHeader, WidgetTitle } from '@forto-dev/phoenix-ui-core/ship'

import { useLocalisation } from '@/utils/localisation'

import { reportsQueryOptions } from './api/reports.service'
import { REPORT_CLUSTERS } from './domain/report'

// import { reportsListFilterAtom } from './domain/filters'
// import { useAtom } from 'jotai'

export const ReportsSidebar: FC = () => {
  const reports = useSuspenseQuery(reportsQueryOptions())
  // const [filter, setFilter] = useAtom(reportsListFilterAtom)
  const total = reports.data.length
  const { translate } = useLocalisation()

  return (
    <Stack gap={16}>
      {/* Disable interaction if it's already selected */}
      <Widget
        variant="primary"
        // variant={!filter ? 'primary' : 'neutral'}
        // onClick={!filter ? undefined : () => setFilter(undefined)}
      >
        <WidgetHeader>
          <WidgetTitle>{translate('reports.total')}</WidgetTitle>
        </WidgetHeader>
        <WidgetFooter>
          <Cluster gap={4} y="center">
            <Icon size="md" name="FileCopy" />
            <Typography variant="h3">{total}</Typography>
          </Cluster>
        </WidgetFooter>
      </Widget>
      {REPORT_CLUSTERS.map((cluster) => {
        const count = reports.data.filter((report) => report.type === cluster.type).length

        return count ? (
          <Widget
            key={cluster.type}
            variant="neutral"
            // to remove functionality of clicking on the widget for beta release
            // variant={filter === cluster.type ? 'primary' : 'neutral'}
            // onClick={filter === cluster.type ? undefined : () => setFilter(cluster.type)}
          >
            <WidgetHeader>
              <WidgetTitle>{cluster.label}</WidgetTitle>
            </WidgetHeader>
            <WidgetFooter>
              <Cluster gap={4} y="center">
                <Icon size="md" name={cluster.icon} />
                <Typography variant="h3">{count}</Typography>
              </Cluster>
            </WidgetFooter>
          </Widget>
        ) : null
      })}
    </Stack>
  )
}
